import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  lrrpCreateRequest,
  lrrpCreateSuccess,
  lrrpCreateFailure,
} = createActions({
  LRRP_CREATE_SUCCESS: json => json,
}, 'LRRP_CREATE_REQUEST', 'LRRP_CREATE_FAILURE');

export function lrrpCreate(lrrpData) {
  return (dispatch) => {
    dispatch(lrrpCreateRequest());
    return create('lrrp', lrrpData)
      .then(({ json }) => dispatch(lrrpCreateSuccess(json)))
      .catch(error => dispatch(lrrpCreateFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/lrrps.js